import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-input-field-number", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("input-field-number", "default-story"),
            componentTag: "ux-input-field-number",
            performActions: async (page) => {
                await page.type(
                    "#ux-unique-id-1",
                    "3232323232323234.3232332323232323"
                );
                await page.focus("#ux-unique-id-1");
                await page.keyboard.type("2");
            },
            pageHeight: 130,
            pageWidth: 400,
        });
    });
});
